var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"indexHome no-trans"},[_c('div',{staticClass:"tops_box"},[_c('headers',{ref:"headers"})],1),_c('div',{staticClass:"cent_box"},[_c('router-view',{key:"home_index"})],1),_c('div',{staticClass:"boms_box"},[_c('bottom',{ref:"bottom"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }